import { render, staticRenderFns } from "./VCommentPrint.vue?vue&type=template&id=e70b54d4&scoped=true&"
import script from "./VCommentPrint.vue?vue&type=script&lang=js&"
export * from "./VCommentPrint.vue?vue&type=script&lang=js&"
import style0 from "./VCommentPrint.vue?vue&type=style&index=0&id=e70b54d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70b54d4",
  null
  
)

export default component.exports